import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { FolderOutlined } from "@/icons"

import styles from "./PlaceholderConfiguration.module.scss"

export const PlaceholderConfiguration = () => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={14} align="center" className={styles.container}>
      <FolderOutlined className={styles.icon} />
      <Text type="secondary">{t("inventory.selectPath")}</Text>
    </Flex>
  )
}
